import { render, staticRenderFns } from "./Listings.vue?vue&type=template&id=bbc00ca4&scoped=true"
import script from "./Listings.vue?vue&type=script&lang=js"
export * from "./Listings.vue?vue&type=script&lang=js"
import style0 from "./Listings.vue?vue&type=style&index=0&id=bbc00ca4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc00ca4",
  null
  
)

export default component.exports